import { BaSeTheme } from '@base/react';
import styled from 'styled-components';

const {
  institucionais: { cinzaSebrae75 },
  defaultColors: { white },
} = BaSeTheme.colors;

export const AppContainerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${white};
  height: 100vh;
`;

export const AppHeaderWrapper = styled.div`
  width: 100%;
  z-index: ${BaSeTheme.stackOrder.aboveNormal};
  position: sticky;
  top: 0;
`;

export const AppBodyWrapper = styled.div`
  display: flex;
  flex: 1;
  position: relative;
  justify-content: center;
  padding: 0 1em;
`;

export const Title = styled.div`
  padding: 0 1em 2em;
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  gap: 0.5em;
`;

export const Content = styled(Title)`
  flex-direction: column;
  padding: 0 0.5em 1em 0.5em;
  gap: 2em;
`;

export const LoadingWrapper = styled.div`
  display: flex;
  min-height: 60vh;
  align-items: center;
  justify-content: center;
`;

export const Separator = styled.hr`
  border: none;
  border-top: 1px solid ${cinzaSebrae75};
  height: 1px;
  width: 100%;
  margin-block: 0.5em;
`;

export const ToEndItems = styled.div`
  display: flex;
  align-items: start;
  justify-content: end;
  gap: 1em;
`;

export const RatingWrapper = styled.div`
  & > div {
    gap: 0 !important;
  }
`;

export const ContentToEnd = styled.div`
  display: flex;
  flex-direction: column;
  align-items: end;
  gap: 0.5em;
  padding: 0.5em;
`;

export const LogoWrapper = styled.div`
  width: 100px;
`;
